// @ts-nocheck
import * as Types from '../../../generated/graphqlTypes';

import { gql } from '@apollo/client';
import { DisplayNamedFragmentDoc, NamedFragmentDoc } from '../../../fragments/commonFragments.generated';
import * as Apollo from '@apollo/client';
import * as ApolloReactHooks from 'src/apolloHooks';
const defaultOptions = {} as const;
export type CommitmentsPageMetadataQueryVariables = Types.Exact<{
  projectId: Types.Scalars['ID']['input'];
}>;


export type CommitmentsPageMetadataQuery = { __typename?: 'Query', commitments: Array<{ __typename?: 'Commitment', id: string, costCodes: Array<{ __typename?: 'CostCode', id: string, displayName: string }> }>, commitmentStatuses: Array<{ __typename?: 'CommitmentStatusDetail', code: Types.CommitmentStatus, name: string }> };

export type CommitmentsPageQueryVariables = Types.Exact<{
  filter?: Types.InputMaybe<Types.CommitmentsFilter>;
}>;


export type CommitmentsPageQuery = { __typename?: 'Query', commitments: Array<{ __typename?: 'Commitment', id: string, name: string, accountingNumber: number, committedInCents: number, pendingBilledInCents?: number | null | undefined, balanceInCents?: number | null | undefined, paidInCents?: number | null | undefined, executionDate?: Types.Scalars['Date']['input'] | null | undefined, pendingRemainingInCents: number, status: Types.CommitmentStatus, statusText: string, updatedAt: Types.Scalars['DateTime']['input'], commitmentType: { __typename?: 'CommitmentTypeDetail', code: Types.CommitmentType, name: string }, changeOrders: Array<{ __typename?: 'CommitmentChangeOrder', id: string, name: string, accountingNumber: number, status: Types.CommitmentStatus, statusText: string, pendingBilledInCents?: number | null | undefined, balanceInCents?: number | null | undefined, paidInCents?: number | null | undefined, pendingRemainingInCents: number, committedInCents: number, executionDate?: Types.Scalars['Date']['input'] | null | undefined, updatedAt: Types.Scalars['DateTime']['input'], commitmentType: { __typename?: 'CommitmentTypeDetail', code: Types.CommitmentType, name: string }, tradeCategories: Array<{ __typename?: 'TradeCategory', id: string, name: string }>, commitment: { __typename?: 'Commitment', id: string, projectStage: { __typename?: 'ProjectStage', id: string, stage: { __typename?: 'StageDetail', code: Types.Stage, name: string } } }, lineItems: Array<{ __typename?: 'CommitmentLineItem', id: string, projectItem: { __typename?: 'ProjectItem', id: string, item: { __typename?: 'Item', id: string, displayName: string } } }> }>, projectStage: { __typename?: 'ProjectStage', id: string, stage: { __typename?: 'StageDetail', code: Types.Stage, name: string } }, lineItems: Array<{ __typename?: 'CommitmentLineItem', id: string, projectItem: { __typename?: 'ProjectItem', id: string, item: { __typename?: 'Item', id: string, displayName: string } } }> }> };

export type CommitmentsPage_CommitmentFragment = { __typename?: 'Commitment', id: string, name: string, accountingNumber: number, committedInCents: number, pendingBilledInCents?: number | null | undefined, balanceInCents?: number | null | undefined, paidInCents?: number | null | undefined, executionDate?: Types.Scalars['Date']['input'] | null | undefined, pendingRemainingInCents: number, status: Types.CommitmentStatus, statusText: string, updatedAt: Types.Scalars['DateTime']['input'], commitmentType: { __typename?: 'CommitmentTypeDetail', code: Types.CommitmentType, name: string }, changeOrders: Array<{ __typename?: 'CommitmentChangeOrder', id: string, name: string, accountingNumber: number, status: Types.CommitmentStatus, statusText: string, pendingBilledInCents?: number | null | undefined, balanceInCents?: number | null | undefined, paidInCents?: number | null | undefined, pendingRemainingInCents: number, committedInCents: number, executionDate?: Types.Scalars['Date']['input'] | null | undefined, updatedAt: Types.Scalars['DateTime']['input'], commitmentType: { __typename?: 'CommitmentTypeDetail', code: Types.CommitmentType, name: string }, tradeCategories: Array<{ __typename?: 'TradeCategory', id: string, name: string }>, commitment: { __typename?: 'Commitment', id: string, projectStage: { __typename?: 'ProjectStage', id: string, stage: { __typename?: 'StageDetail', code: Types.Stage, name: string } } }, lineItems: Array<{ __typename?: 'CommitmentLineItem', id: string, projectItem: { __typename?: 'ProjectItem', id: string, item: { __typename?: 'Item', id: string, displayName: string } } }> }>, projectStage: { __typename?: 'ProjectStage', id: string, stage: { __typename?: 'StageDetail', code: Types.Stage, name: string } }, lineItems: Array<{ __typename?: 'CommitmentLineItem', id: string, projectItem: { __typename?: 'ProjectItem', id: string, item: { __typename?: 'Item', id: string, displayName: string } } }> };

export type CommitmentsPage_ChangeOrderFragment = { __typename?: 'CommitmentChangeOrder', id: string, name: string, accountingNumber: number, status: Types.CommitmentStatus, statusText: string, pendingBilledInCents?: number | null | undefined, balanceInCents?: number | null | undefined, paidInCents?: number | null | undefined, pendingRemainingInCents: number, committedInCents: number, executionDate?: Types.Scalars['Date']['input'] | null | undefined, updatedAt: Types.Scalars['DateTime']['input'], commitmentType: { __typename?: 'CommitmentTypeDetail', code: Types.CommitmentType, name: string }, tradeCategories: Array<{ __typename?: 'TradeCategory', id: string, name: string }>, commitment: { __typename?: 'Commitment', id: string, projectStage: { __typename?: 'ProjectStage', id: string, stage: { __typename?: 'StageDetail', code: Types.Stage, name: string } } }, lineItems: Array<{ __typename?: 'CommitmentLineItem', id: string, projectItem: { __typename?: 'ProjectItem', id: string, item: { __typename?: 'Item', id: string, displayName: string } } }> };

export const CommitmentsPage_ChangeOrderFragmentDoc = gql`
    fragment CommitmentsPage_ChangeOrder on CommitmentChangeOrder {
  id
  name
  accountingNumber
  commitmentType {
    code
    name
  }
  status
  statusText
  pendingBilledInCents
  balanceInCents
  paidInCents
  pendingRemainingInCents
  committedInCents
  executionDate
  updatedAt
  tradeCategories {
    id
    name
  }
  commitment {
    id
    projectStage {
      id
      stage {
        code
        name
      }
    }
  }
  lineItems {
    id
    projectItem {
      id
      item {
        id
        displayName
      }
    }
  }
}
    `;
export const CommitmentsPage_CommitmentFragmentDoc = gql`
    fragment CommitmentsPage_Commitment on Commitment {
  id
  name
  accountingNumber
  commitmentType {
    code
    name
  }
  committedInCents
  pendingBilledInCents
  balanceInCents
  paidInCents
  executionDate
  pendingRemainingInCents
  status
  statusText
  updatedAt
  changeOrders {
    ...CommitmentsPage_ChangeOrder
  }
  projectStage {
    id
    stage {
      code
      name
    }
  }
  lineItems {
    id
    projectItem {
      id
      item {
        id
        displayName
      }
    }
  }
}
    ${CommitmentsPage_ChangeOrderFragmentDoc}`;
export const CommitmentsPageMetadataDocument = gql`
    query CommitmentsPageMetadata($projectId: ID!) {
  commitments(filter: {projectId: $projectId}, first: 10000) {
    id
    costCodes {
      ...DisplayNamed
    }
  }
  commitmentStatuses {
    code
    name
  }
}
    ${DisplayNamedFragmentDoc}`;

/**
 * __useCommitmentsPageMetadataQuery__
 *
 * To run a query within a React component, call `useCommitmentsPageMetadataQuery` and pass it any options that fit your needs.
 * When your component renders, `useCommitmentsPageMetadataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCommitmentsPageMetadataQuery({
 *   variables: {
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function useCommitmentsPageMetadataQuery(baseOptions: ApolloReactHooks.QueryHookOptions<CommitmentsPageMetadataQuery, CommitmentsPageMetadataQueryVariables> & ({ variables: CommitmentsPageMetadataQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<CommitmentsPageMetadataQuery, CommitmentsPageMetadataQueryVariables>(CommitmentsPageMetadataDocument, options);
      }
export function useCommitmentsPageMetadataLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<CommitmentsPageMetadataQuery, CommitmentsPageMetadataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<CommitmentsPageMetadataQuery, CommitmentsPageMetadataQueryVariables>(CommitmentsPageMetadataDocument, options);
        }
export function useCommitmentsPageMetadataSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<CommitmentsPageMetadataQuery, CommitmentsPageMetadataQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<CommitmentsPageMetadataQuery, CommitmentsPageMetadataQueryVariables>(CommitmentsPageMetadataDocument, options);
        }
export type CommitmentsPageMetadataQueryHookResult = ReturnType<typeof useCommitmentsPageMetadataQuery>;
export type CommitmentsPageMetadataLazyQueryHookResult = ReturnType<typeof useCommitmentsPageMetadataLazyQuery>;
export type CommitmentsPageMetadataSuspenseQueryHookResult = ReturnType<typeof useCommitmentsPageMetadataSuspenseQuery>;
export type CommitmentsPageMetadataQueryResult = Apollo.QueryResult<CommitmentsPageMetadataQuery, CommitmentsPageMetadataQueryVariables>;
export const CommitmentsPageDocument = gql`
    query CommitmentsPage($filter: CommitmentsFilter) {
  commitments(filter: $filter, first: 10000) {
    ...CommitmentsPage_Commitment
  }
}
    ${CommitmentsPage_CommitmentFragmentDoc}`;

/**
 * __useCommitmentsPageQuery__
 *
 * To run a query within a React component, call `useCommitmentsPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useCommitmentsPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCommitmentsPageQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useCommitmentsPageQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<CommitmentsPageQuery, CommitmentsPageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<CommitmentsPageQuery, CommitmentsPageQueryVariables>(CommitmentsPageDocument, options);
      }
export function useCommitmentsPageLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<CommitmentsPageQuery, CommitmentsPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<CommitmentsPageQuery, CommitmentsPageQueryVariables>(CommitmentsPageDocument, options);
        }
export function useCommitmentsPageSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<CommitmentsPageQuery, CommitmentsPageQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<CommitmentsPageQuery, CommitmentsPageQueryVariables>(CommitmentsPageDocument, options);
        }
export type CommitmentsPageQueryHookResult = ReturnType<typeof useCommitmentsPageQuery>;
export type CommitmentsPageLazyQueryHookResult = ReturnType<typeof useCommitmentsPageLazyQuery>;
export type CommitmentsPageSuspenseQueryHookResult = ReturnType<typeof useCommitmentsPageSuspenseQuery>;
export type CommitmentsPageQueryResult = Apollo.QueryResult<CommitmentsPageQuery, CommitmentsPageQueryVariables>;